import type { IconData } from '@stacksjs/iconify-core'

export const pl1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#fff\" d=\"M512 512H0V0h512z\"/><path fill=\"#dc143c\" d=\"M512 512H0V256h512z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default pl1x1
